import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ReactSession } from 'react-client-session';
import { useNavigate, useParams } from 'react-router-dom';
import Header from './header';
import Footer from './footer';
ReactSession.setStoreType("localStorage");

function App() {
    
    const navigate = useNavigate();
    const userId = sessionStorage.getItem('jmpiUserId');
    
    useEffect(()=>{
        if(!userId || userId === 0 || userId === null){
          alert('runnig')
            //navigate('/login');
            window.location =`/login`;
        }
    },[userId]);

    const [userData, setUserData] = useState('');
    const [shippingData, setShippingData] = useState('');
    const [addressData, setAddressData] = useState('');
    const [orderData, setOrderData] = useState('');
    const [selectedsCountry, setSelectedsCountry] = useState('ind');
    const [isShip, setIsShip] = useState(false);
    const [SformData, setsFormData] = useState({ userId: userId, sFirstname: '', sLastname: '', sAdrs1:'', sAdrs2: '', sTown:'', sZip:'', sState:'', sEmail: '', sPhone: '', sContry: ''});
    const [BformData, setbFormData] = useState({ userId: userId, sFirstname: '', sLastname: '', sAdrs1:'', sAdrs2: '', sTown:'', sZip:'', sState:'', sEmail: '', sPhone: '', sContry: '', curPass: '', newPass1: '', newPass2: '', pass: isShip});
    const [passError, setPassError] = useState('');
    const [msg, setMsg] = useState('');
    const [getUrl, setGetUrl] = useState(false);
    const [getUrlData, setGetUrlData] = useState(false);

    useEffect(() => {
        if(getUrl === false){
            const url = window.location.href;
            const hash = url.split('#')[1];
            setGetUrlData(hash);
            setGetUrl(true);
        }
    },[]);

    const logout = () => {
        sessionStorage.removeItem('jmpiUserId');
        //navigate('/login');
        window.location =`/login`;
    };

    

    const getUserData = async () => {
      const user = {userId: userId};
      try{
        const response = await axios.post('https://demo.sninfoserv.com/api/customer/data/', user);
        console.log(response.data);
        if(response.data.status === 'success'){
            setUserData(response.data.userData);
            setShippingData(response.data.shippingAddress);
            setAddressData(response.data.billingAddress);
            setOrderData(response.data.orderData);
        }
      }catch (error){
        console.error(error);
      }
    

    };

    useEffect(() => {
        getUserData();
    },[userId, userData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setsFormData({
          ...SformData,
          [name]: value
        });
    };

    const handleBillingChange = (e) => {
        const { name, value } = e.target;
        setbFormData({
          ...BformData,
          [name]: value
        });
    };

    const CountryName = (selectedCountry) => {
    
        let country;
        switch (selectedCountry) {
          case 'usa':
            country = 'United States';
            break;
          case 'uk':
            country = 'United Kingdom';
            break;
          case 'fra':
            country = 'France';
            break;
          case 'aus':
            country = 'Australia';
            break;
          case 'can':
            country = 'Canada';
            break;
          case 'nz':
            country = 'New Zealand';
            break;
          case 'ger':
            country = 'Germany';
            break;
          case 'net':
            country = 'Netherlands';
            break;
          case 'den':
            country = 'Denmark';
            break;
          case 'ita':
            country = 'Italy';
            break;
          case 'ire':
            country = 'Ireland';
            break;
          case 'bel':
            country = 'Belgium';
            break;
          case 'por':
            country = 'Portugal';
            break;
          case 'swe':
            country = 'Sweden';
            break;
          case 'sin':
            country = 'Singapore';
            break;
          case 'dub':
            country = 'Dubai';
            break;
          case 'mal':
            country = 'Malaysia';
            break;
          case 'ind':
            country = 'India';
            break;
          default:
            country = 'Select a Country';
        }
        return country;
    };

    useEffect(() => {
        setsFormData({
            ...SformData,
            ['sContry']: CountryName(selectedsCountry)
        });
        setbFormData({
            ...BformData,
            ['sFirstname']: addressData?.fName,
            ['sLastname']: addressData?.lName,
            ['sEmail']: addressData?.email,
            ['sPhone']: addressData?.mobile,
            ['sAdrs1']: addressData?.adrs1,
            ['sAdrs2']: addressData?.adrs2,
            ['sTown']: addressData?.town,
            ['sState']: addressData?.state,
            ['sContry']: addressData?.country,
            ['sZip']: addressData?.zip

        });

    },[selectedsCountry, addressData]);

    const addAddress = async (e) => {
        e.preventDefault();
      try{
        const response = await axios.post('https://demo.sninfoserv.com/api/customer/address/', SformData);
        if(response.data.status === 'success'){
          getUserData();
          setsFormData({ userId: userId, sFirstname: '', sLastname: '', sAdrs1:'', sAdrs2: '', sTown:'', sZip:'', sState:'', sEmail: '', sPhone: '', sContry: ''});
        }
      } catch(error){
        console.error(error);
      }
    };

    const removeAddress = async (adrsId) => {
     
        try{
            const response = await axios.get('https://demo.sninfoserv.com/api/customer/address/', {params: { adrsId }});
            console.log(response.data);
            if(response.data.status === 'success'){
                getUserData();
              }
        }catch(error){
            console.error(error);
        }
    };

    const handleShipAddress = () =>{

        if (isShip === false) {
            setIsShip(true);
            setbFormData({
                ...BformData,
                ['pass']: true
            });
        } else {
            setIsShip(false);
            setbFormData({
                ...BformData,
                ['pass']: false
            });
        }
    };

    const updateProfile = async (e) => {
        e.preventDefault();
        if(isShip){
            if(BformData.newPass1 !== BformData.newPass2){
                setPassError('New Password & Confirm Password not matching!');
                setMsg('');
            }else{
                if(BformData.curPass !== userData.unId){
                    setPassError('Old Password not matching!');
                    setMsg('');
                }else{
                    setPassError('');
                    try{
                        const response = await axios.post('https://demo.sninfoserv.com/api/customer/update/', BformData);
                        console.log(response.data);
                        if(response.data.status === 'success'){
                            getUserData();
                            setMsg('Account details updated!');
                            setPassError('');
                        }else{
                            setPassError('Server error please try again later!');
                        }

                    }catch(error){
                        console.error(error);
                        setPassError('Server error please try again later!');
                    }
                }
            }
        }else{
        
          try{
            const response = await axios.post('https://demo.sninfoserv.com/api/customer/update/', BformData);
            console.log(response.data);
            if(response.data.status === 'success'){
                getUserData();
                setMsg('Account details updated!');
                setPassError('');
            }else{
                setPassError('Server error please try again later!');
            }
          }catch(error){
            setPassError('Server error please try again later!');
            console.error(error);
          }
        }
    };
  
    //console.log(userData);
    
    return (
        <div class="page-wrapper">
          <h1 class="d-none">Jampani Pickles</h1>
          <Header />  
          <main class="main order">

            <nav class="breadcrumb-nav">
                <div class="container">
                    <ul class="breadcrumb">
                        <li><a href="/">Home</a></li>
                        <li>My account {userId}</li>
                    </ul>
                </div>
            </nav>

            <div class="page-content pt-2">
                <div class="container">
                    <div class="tab tab-vertical row gutter-lg">
                        <ul class="nav nav-tabs mb-6" role="tablist">
                            <li class="nav-item">
                                <a href="#account-dashboard" class={`nav-link ${!getUrlData ? 'active' : ''}`}>Dashboard</a>
                            </li>
                            <li class="nav-item">
                                <a href="#account-orders" class="nav-link">Orders</a>
                            </li>
                            <li class="nav-item">
                                <a href="#account-addresses" class={`nav-link ${getUrlData === 'address' ? 'active' : ''}`}>Addresses</a>
                            </li>
                            <li class="nav-item">
                                <a href="#account-details" class={`nav-link ${getUrlData === 'account' ? 'active' : ''}`}>Account details</a>
                            </li>
                            <li class="link-item">
                                <a href="wishlist.html" class="nav-link">Wishlist</a>
                            </li>
                            <li class="link-item">
                                <a onClick={logout} href="#" class="nav-link">Logout</a>
                            </li>
                        </ul>

                        <div class="tab-content mb-6">
                            <div class={`tab-pane ${!getUrlData ? 'active in' :''}`} id="account-dashboard">
                                <p class="greeting">
                                    Hello
                                    <span class="text-dark font-weight-bold"> {userData?.fName} {userData?.lName}</span>
                                    ( not
                                    <span class="text-dark font-weight-bold"> {userData?.fName} {userData?.lName} </span> ?
                                    <a onClick={logout} href="#" class="text-primary"> Logout</a> )
                                </p>

                                <p class="mb-4">
                                    From your account dashboard you can view your <a href="#account-orders"
                                        class="text-primary link-to-tab">recent orders</a>,
                                    manage your <a href="#account-addresses" class="text-primary link-to-tab">shipping
                                        and billing
                                        addresses</a>, and
                                    <a href="#account-details" class="text-primary link-to-tab">edit your password and
                                        account details.</a>
                                </p>

                                <div class="row">
                                    <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                                        <a href="#account-orders" class="link-to-tab">
                                            <div class="icon-box text-center">
                                                <span class="icon-box-icon icon-orders">
                                                    <i class="w-icon-orders"></i>
                                                </span>
                                                <div class="icon-box-content">
                                                    <p class="text-uppercase mb-0">Orders</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    
                                    <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                                        <a href="#account-addresses" class="link-to-tab">
                                            <div class="icon-box text-center">
                                                <span class="icon-box-icon icon-address">
                                                    <i class="w-icon-map-marker"></i>
                                                </span>
                                                <div class="icon-box-content">
                                                    <p class="text-uppercase mb-0">Addresses</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                                        <a href="#account-details" class="link-to-tab">
                                            <div class="icon-box text-center">
                                                <span class="icon-box-icon icon-account">
                                                    <i class="w-icon-user"></i>
                                                </span>
                                                <div class="icon-box-content">
                                                    <p class="text-uppercase mb-0">Account Details</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                                        <a href="wishlist.html" class="link-to-tab">
                                            <div class="icon-box text-center">
                                                <span class="icon-box-icon icon-wishlist">
                                                    <i class="w-icon-heart"></i>
                                                </span>
                                                <div class="icon-box-content">
                                                    <p class="text-uppercase mb-0">Wishlist</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-lg-4 col-md-6 col-sm-4 col-xs-6 mb-4">
                                        <a href="#" onClick={logout}>
                                            <div class="icon-box text-center">
                                                <span class="icon-box-icon icon-logout">
                                                    <i class="w-icon-logout"></i>
                                                </span>
                                                <div class="icon-box-content">
                                                    <p class="text-uppercase mb-0">Logout</p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane mb-4" id="account-orders">
                                <div class="icon-box icon-box-side icon-box-light mt-4 mb-4">
                                    <span class="icon-box-icon icon-orders">
                                        <i class="w-icon-orders"></i>
                                    </span>
                                    <div class="icon-box-content">
                                        <h4 class="icon-box-title text-capitalize ls-normal mb-0">Orders</h4>
                                    </div>
                                </div>

                                <table class="shop-table account-orders-table mb-6">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Order ID</th>
                                            <th class="text-left">Date</th>
                                            <th class="text-left">Status</th>
                                            <th class="text-left">Total</th>
                                            <th class="text-left">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {orderData && orderData?.map((order, index) =>
                                        <tr key={index}>
                                            <td class="order-id">{order.orderId}</td>
                                            <td class="order-date">{order.time}</td>
                                            <td class="order-status">{order.status}</td>
                                            <td class="order-total">
                                                <span class="order-price">₹ {Number(order.total).toFixed(2)}</span> for
                                                <span class="order-quantity"> {order.items}</span> item
                                            </td>
                                            <td class="order-action">
                                                <a href={`/order?id=${order.orderId}`}
                                                    class="btn btn-outline btn-default btn-block btn-sm btn-rounded">View</a>
                                            </td>
                                        </tr>
                                      )}
                                    </tbody>
                                </table>

                                <a href="/" class="btn btn-dark btn-rounded btn-icon-right">Go
                                    Shop<i class="w-icon-long-arrow-right"></i></a>
                            </div>

                            <div class={`tab-pane ${getUrlData === 'address' ? 'active in' :''}`} id="account-addresses">
                                <div class="icon-box icon-box-light">
                                    <span class="icon-box-icon icon-map-marker">
                                        <i class="w-icon-map-marker"></i>
                                    </span>
                                    <div class="">
                                        <h4 class="icon-box-title mb-0 ls-normal"> Addresses</h4>
                                    </div>
                                </div>
                                <p>The following addresses will be used on the checkout page by default. You can add upto 6 addresses!</p>
                                <div class="row mt-4">
                                    {shippingData && shippingData?.map((address, index) => 
                                        <div class="col-sm-6 mb-6" key={index}>
                                            <div style={{border: '1px solid #333', borderRadius: '10px', padding: '10px'}}>
                                                <p>
                                                    <b>{address.fName} {address.lName}</b><br />
                                                    {address.adrs1}, {address.adrs2}<br />
                                                    {address.town}, {address.state}, {address.country} - {address.zip}<br /><br />
                                                    {address.phone} <br />
                                                    {address.email}
                                                    <a onClick={()=> removeAddress(address.adrsId)} style={{position: 'absolute', float: 'right', right: '30px', top: '20px', color: '#e32c2b', fontSize:'15px'}}><i class="fas fa-trash"></i></a>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                    {shippingData.length < 6 ? 
                                    <div class="col-sm-12 mb-12">
                                        <div class="ecommerce-address shipping-address pr-lg-8">
                                            <h4 class="title title-underline ls-25 font-weight-bold">Add Shipping Address</h4>
                                            <address class="mb-4">
                                                <form onSubmit={addAddress}>
                                                <div class="row">
                                                    <div class="col-sm-6 mb-6">
                                                      <input type="text" class="form-control" placeholder="First Name" name="sFirstname" value={SformData.sFirstname} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-6 mb-6">
                                                      <input type="text" class="form-control" placeholder="Last Name" name="sLastname" value={SformData.sLastname} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-6 mb-6">
                                                      <input type="email" class="form-control" placeholder="Email" name="sEmail" value={SformData.sEmail} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-6 mb-6">
                                                      <input type="text" class="form-control" placeholder="Phone" name="sPhone" value={SformData.sPhone} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-12 mb-12 mb-4">
                                                      <input type="text" class="form-control" placeholder="Address Line 1" name="sAdrs1" value={SformData.sAdrs1} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-12 mb-12 mb-4">
                                                      <input type="text" class="form-control" placeholder="Address Line 2" name="sAdrs2" value={SformData.sAdrs2} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-3 mb-3">
                                                      <input type="text" class="form-control" placeholder="Town/City/Place" name="sTown" value={SformData.sTown} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-3 mb-3">
                                                      <input type="text" class="form-control" placeholder="State/ Province" name="sState" value={SformData.sState} onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-3 mb-3">
                                                        <select name="sContry" class="form-control form-control-md" onChange={(e)=> setSelectedsCountry(e.target.value)} required>
                                                            <option value={selectedsCountry} hidden selected>{SformData.sContry} </option>     
                                                            <option value="ind">India</option>
                                                            <option value="usa">United States</option>
                                                            <option value="uk">United Kingdom</option>
                                                            <option value="fra">France</option>
                                                            <option value="aus">Australia</option>
                                                            <option value="can">Canada</option>
                                                            <option value="nz">New Zealand</option>
                                                            <option value="ger">Germany</option>
                                                            <option value="net">Netherlands</option>
                                                            <option value="den">Denmark</option>
                                                            <option value="ita">Italy</option>
                                                            <option value="ire">Ireland</option>
                                                            <option value="bel">Belgium</option>
                                                            <option value="por">Portugal</option>
                                                            <option value="swe">Sweden</option>
                                                            <option value="sin">Singapore</option>
                                                            <option value="dub">Dubai</option>
                                                            <option value="mal">Malaysia</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-3 mb-3">
                                                      <input type="text" class="form-control" placeholder="Zip" value={SformData.sZip} name="sZip" onChange={handleChange} required />
                                                    </div>
                                                    <div class="col-sm-12 mb-12" align="center">
                                                      <button class="btn btn-primary" type="submit">Add Address</button>
                                                    </div>
                                                </div>
                                                </form>
                                            </address>
                                          </div>
                                    </div>
                                    :
                                    <div class="col-sm-12 mb-12">
                                        <div class="ecommerce-address shipping-address pr-lg-8">
                                            <h4 class="title title-underline ls-25 font-weight-bold">Add Shipping Address</h4>
                                            <address class="mb-4">
                                                <p>You're reached address limit! You can delete existing address to add more address.</p>
                                            </address>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>

                            <div class={`tab-pane ${getUrlData === 'account' ? 'active in' :''}`} id="account-details">
                                <div class="icon-box icon-box-side icon-box-light">
                                    <span class="icon-box-icon icon-account mr-2">
                                        <i class="w-icon-user"></i>
                                    </span>
                                    <div class="icon-box-content">
                                        <h4 class="icon-box-title mb-0 ls-normal">Account Details</h4>
                                    </div>
                                </div>
                                <form class="form account-details-form" onSubmit={updateProfile}>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="firstname">First name *</label>
                                                <input type="text" id="firstname" name="sFirstname" value={BformData.sFirstname} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="lastname">Last name *</label>
                                                <input type="text" id="lastname" name="sLastname" value={BformData.sLastname} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="lastname">Email *</label>
                                                <input type="email" id="lastname" name="sEmail" value={BformData.sEmail} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label for="lastname">Phone *</label>
                                                <input type="text" id="lastname" name="sPhone" value={BformData.sPhone} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="lastname">Address Line 1 *</label>
                                                <input type="text" id="lastname" name="sAdrs1" value={BformData.sAdrs1} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="lastname">Address Line 2 *</label>
                                                <input type="text" id="lastname" name="sAdrs2" value={BformData.sAdrs2} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="lastname">City/Town *</label>
                                                <input type="text" id="lastname" name="sTown" value={BformData.sTown} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="lastname">State/Province *</label>
                                                <input type="text" id="lastname" name="sState" value={BformData.sState} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="lastname">Country *</label>
                                                <input type="text" id="lastname" name="sContry" value={BformData.sContry} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group checkbox-toggle pb-2">
                                        <input type="checkbox" class="custom-checkbox" id="shipping-toggle" name="shipping-toggle" onClick={handleShipAddress} />
                                        <label for="shipping-toggle" onClick={handleShipAddress}>Change Password ?</label>
                                    </div>
                                    <div class={`checkbox-content ${isShip ? 'open' : ''}`} id="passChange" style={{display: isShip ? 'block' : 'none'}}>
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="firstname">Current Password *</label>
                                                <input type="text" id="firstname" name="curPass" value={BformData.curPass} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="firstname">New Password *</label>
                                                <input type="text" id="firstname" name="newPass1" value={BformData.newPass1} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="firstname">Confirm New Password *</label>
                                                <input type="text" id="firstname" name="newPass2" value={BformData.newPass2} onChange={handleBillingChange}
                                                    class="form-control form-control-md" />
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    {passError.length > 0 && <p class="text-danger">{passError}</p> }
                                    {msg.length > 0 && <p class="text-success">{msg}</p> }
                                    <button type="submit" class="btn btn-dark btn-rounded btn-sm mb-4">Save Changes</button>
                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
         </main>
          <Footer />
        </div>
  );
}

export default App;